<template>
  <van-popup v-model:show="show" @click-overlay="closePopup" teleport="body" :style="{ width: '60%', height: '24%', display: 'flex' }">
    <div class="popup">
      <van-button square class="bind-car-button" type="primary" text="去绑车" @click="linkTo('/editCarInfo', { isCreate: true, event: '新增车辆' })" />
      <van-button square type="default" text="稍后绑车" @click="closePopup" />
    </div>
  </van-popup>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { myCarList } from '@/api/car'

export default {
  setup() {
    const router = useRouter()
    const store = useStore()
    const { openCompleteInfoPopup } = store.state

    const state = reactive({
      show: false
    })

    onMounted(async () => {
      if (openCompleteInfoPopup) {
        // 用户未绑车时,显示弹窗
        let { list } = await myCarList()
        if (list && list.length) {
          store.commit('SETOPENCOMPLETEINFOPOPUP', false)
          return
        }
        state.show = true
      }
    })

    const linkTo = (path, query) => {
      closePopup()
      router.push({ path, query })
    }

    const closePopup = () => {
      state.show = false
      store.commit('SETOPENCOMPLETEINFOPOPUP', false)
    }

    return {
      ...toRefs(state),
      linkTo,
      closePopup
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  padding: 10%;
  align-items: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.bind-car-button {
  margin-bottom: 5%;
}
</style>
